var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("app-divider", {
        staticClass: "container-input",
        attrs: { label: "Custas processuais", showBorder: true }
      }),
      _c(
        "div",
        { staticClass: "custas" },
        [
          _c(
            "el-checkbox-group",
            {
              on: { change: _vm.handleChange },
              model: {
                value: _vm.custasVtn,
                callback: function($$v) {
                  _vm.custasVtn = $$v
                },
                expression: "custasVtn"
              }
            },
            [
              _c(
                "el-row",
                _vm._l(_vm.tiposCustas, function(custa) {
                  return custa.grupo === "PROCESSUAIS"
                    ? _c(
                        "el-checkbox",
                        {
                          key: custa.id,
                          staticClass: "checkbox",
                          attrs: {
                            checked: _vm.selecionado(custa.id),
                            label: custa
                          }
                        },
                        [
                          _c("div", { staticClass: "label" }, [
                            _vm._v(_vm._s(custa.descricao))
                          ])
                        ]
                      )
                    : _vm._e()
                }),
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("app-divider", {
        staticClass: "container-input",
        attrs: { label: "Custas agrárias", showBorder: true }
      }),
      _c(
        "div",
        { staticClass: "custas" },
        _vm._l(
          _vm.tiposCustas.filter(function(item) {
            return item.grupo === "AGRARIAS"
          }),
          function(custa) {
            return _c(
              "div",
              { staticClass: "input-custas" },
              [
                _c("span", { staticClass: "span-item" }, [
                  _vm._v(_vm._s(custa.descricao))
                ]),
                _c("el-input-number", {
                  staticClass: "input-item",
                  attrs: {
                    value: _vm.getCustaValue(custa.id),
                    min: 0,
                    size: "small"
                  },
                  on: {
                    change: function($event) {
                      return _vm.handleChangeAgraria($event, custa)
                    }
                  }
                })
              ],
              1
            )
          }
        ),
        0
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-700559ca", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-700559ca","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/financeiro/vtn/CustasVtn.vue
// module id = null
// module chunks = 